<template>
    <div class="giving giving-extra p-5">
        <h3 class="uppercase text-white font-bold text-20 mb-1">
            {{ $t("Multiply your impact!") }}
        </h3>
        <p class="text-14 tracking-normal text-white leading-tight">
            {{ srtReplace() }}
        </p>
        <div class="giving-chooser pt-8 pb-2">
            <ul
                ref="givingChooser"
                class="mb-2 giving-chooser__list flex flex-nowrap bg-white relative"
            >
                <li
                    class="giving-chooser__item flex-grow flex"
                    v-for="item in multiplyNumber"
                    :key="item"
                >
                    <button
                        v-ripple
                        type="button"
                        :ref="`multiply${item}x`"
                        class="giving-chooser__btn text-16 font-bold tracking-tight text-center w-full"
                        :class="{
                            'active-extra': item === multiply
                        }"
                        @click="chooserExtraHandler(item)"
                    >
                        {{ item }}x
                    </button>
                </li>
                <li
                    class="absolute giving-chooser__item-bg"
                    v-bind:style="styles"
                ></li>
            </ul>
            <Button
                type="button"
                :click-handler="addMultiply"
                classes="table mx-auto pt-5"
                :text="$t('Set Multiplier')"
            ></Button>
        </div>
    </div>
</template>

<script>
import Button from "../UI/Button";
import mixins from "../../config/mixins";
export default {
    name: "Impact",
    mixins: [mixins.helpers],
    components: { Button },

    data: function() {
        return {
            multiplyNumber: ["1", "2", "3", "10"],
            styles: {
                width: "",
                left: "",
                right: ""
            },
            currentRefName: "multiply1x",
            multiply: "1"
        };
    },

    mounted() {
        this.currentRefName = this.$user("multiply")
            ? `multiply${this.$user("multiply")}x`
            : "multiply1x";
        this.multiply = this.$user("multiply") ? this.$user("multiply") : "1";
        this.generateStyles();
        window.addEventListener("resize", () => {
            this.generateStyles();
        });
        setTimeout(() => {
            this.multiply = this.$user("multiply")
                ? this.$user("multiply")
                : "1";
            this.currentRefName = this.$user("multiply")
                ? `multiply${this.$user("multiply")}x`
                : "multiply1x";
            this.generateStyles();
        }, 500);
    },

    methods: {
        srtReplace: function() {
            let str = this.$t("You are donating {times} your change.");
            return str.replace("{times}", this.multiply + "x");
        },
        chooserExtraHandler: function(val) {
            this.currentRefName = `multiply${val}x`;
            this.generateStyles();
            this.multiply = val;
        },
        addMultiply: function() {
            this.$fire({
                type: "warning",
                title: `Would you like to change your impact to ${this.multiply}x?`,
                showCancelButton: true,
                cancelButtonText: "No",
                confirmButtonText: "Yes"
            }).then(r => {
                if (!!r.value && r.value) {
                    this.$http
                        .post("user/savedonation", {
                            monthly_minimum_goal: this.$user(
                                "monthly_minimum_goal"
                            ),
                            maximum_donation: this.$user("maximum_donation"),
                            roundup_amount: this.$user("roundup_amount"),
                            pause: this.$user("is_pause_donation"),
                            multiply: this.multiply
                        })
                        .then(data => {
                            if (
                                data &&
                                data.status !== undefined &&
                                data.status
                            ) {
                                this.$setState("userUpdate", {
                                    multiply: this.multiply
                                });
                            }
                        });
                }
            });
        }
    }
};
</script>
